import * as actions from './actions';
import * as mutations from './mutations';
import state from './state';

const reportes = {
   namespaced: true,
   actions,
   mutations,
   state,
};

export default reportes;
